import { InformationSlabBoxIcon } from './InformationSlabBoxIcon';

/**
 * author: Jeff Anders
 * id 5E1C3338-5309-4631-A9A9-9D41E4CEC8A7
 * name information-slab-box
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information-slab-box.svg
 * tags
 * - Settings 
 */
export const InfoSlabBoxIcon = InformationSlabBoxIcon;
export default InfoSlabBoxIcon